import React, { useEffect, useContext } from 'react'
import Header from './components/Header/index.js'
import LandingHero from './components/LandingHero/index.js'
import LandingHeroHoliday from './components/LandingHeroHoliday/index.js'
import LandingFeatures from './components/LandingFeatures/index.js'
import LandingPartners from './components/LandingPartners/index.js'
import LandingAdvantages from './components/LandingAdvantages/index.js'
import LandingDescription from './components/LandingDescription/index.js'
import LandingTestimonials from './components/LandingTestimonials/index.js'
import LandingServicing from './components/LandingServicing/index.js'
import LandingExpress from './components/LandingExpress/index.js'
import LandingEmail from './components/LandingEmail/index.js'
import LandingFaq from './components/LandingFaq/index.js'
import LandingFooter from './components/LandingFooter/index.js'
import WhatsAppButton from 'components/WhatsAppButton'
import LandingLayout from '../../layouts/LandingLayout'
import storage from 'utils/storage'
import { addNRPageView } from 'utils/trackings/newRelicEvents.js'
import isClient from 'utils/isClient.js'
import analyticsUuid from 'utils/analyticsUuid.js'
import { ThemeContext } from 'modules/Theme'
import './Landing.scss'
import handleInternalTracking from 'utils/trackings/handleInternalTracking.js'
import analytics from '@mobi/libraries/analytics'

const DynamicComponent = ({ blok, location, holiday, overlap }) => {
  let Components = {
    lp_header: Header,
    lp_express: LandingExpress,
    lp_servicing: LandingServicing,
    lp_features: LandingFeatures,
    lp_partners: LandingPartners,
    lp_advantages: LandingAdvantages,
    lp_description: LandingDescription,
    lp_testimonials: LandingTestimonials,
    lp_faq: LandingFaq,
    lp_email: LandingEmail,
    lp_footer: LandingFooter,
  }

  if (holiday) {
    Components = { ...Components, lp_hero_holiday: LandingHeroHoliday }
  } else {
    Components = { ...Components, lp_hero: LandingHero }
  }

  const Component = Components[blok.component]

  return Component ? (
    <Component
      blok={blok}
      location={location}
      holiday={holiday}
      overlap={overlap}
    />
  ) : null
}

const Landing = ({ location, pageContext }) => {
  const { setTheme } = useContext(ThemeContext)

  useEffect(() => {
    analyticsUuid.clearKeepingAnalyticsUuid()

    storage.local.setItem('callbackUrl', isClient() && window.location.href)

    storage.session.setItem('keepSession', true)

    storage.local.removeItem('isLojasAvenida')

    const isLojasAvenida = storage.local.getItem('isLojasAvenida')
    const origin = isLojasAvenida ? 'recovery' : pageContext?.slug
    setTheme(origin || 'recovery')

    if (window.location.href.includes('lojasavenida')) {
      storage.local.setItem('isLojasAvenida', true)
      setTheme('recovery')
    }

    addNRPageView('lp_home')
    analytics.track('gaPageLoad', {
      pageName: 'LandingPage:RenegocieGrupoRecovery:RV',
    })
    handleInternalTracking('lp_visit')
  }, [])

  let blok = pageContext?.data?.content
  blok = blok && JSON.parse(blok)

  const content = blok?.body?.map((childBlok) => (
    <DynamicComponent
      blok={childBlok}
      key={childBlok._uid}
      location={location}
      holiday={blok.holiday}
      overlap={blok.overlap_header}
    />
  ))

  return (
    <LandingLayout>
      <WhatsAppButton
        content={blok?.body?.find(
          ({ component }) => component === 'lp_whatsapp'
        )}
        dataUnique="05c0b568-1a74-4bb4-8d32-e0308b942750"
      />
      <div className="landing-container">{content ? content : null}</div>
    </LandingLayout>
  )
}

export default Landing
